import { Users, Store, Building2, Activity, Shirt, BadgeCheck, GraduationCap, DollarSign, Sun, Wifi } from "lucide-react";

const ROWS = [
  ["public", "Deals with the public", Store],
  ["people", "People around you", Users],
  ["environment", "Work environment", Building2],
  ["setting", "Indoor / outdoor", Sun],
  ["remote", "Remote work", Wifi],
  ["physical", "Physical demand", Activity],
  ["gear", "Supplies, gear & clothing", Shirt],
  ["certifications", "Certification / licensing", BadgeCheck],
  ["training", "Training path", GraduationCap],
  ["pay", "Typical pay (US, approx.)", DollarSign],
];

export const CareerFacts = ({ career }) => (
  <div data-testid="career-facts" className="grid sm:grid-cols-2 gap-px bg-[#1C242B]/10 rounded-2xl overflow-hidden border border-[#1C242B]/10">
    {ROWS.map(([k, label, Icon]) => (
      <div key={k} className="bg-white p-5" data-testid={`career-fact-${k}`}>
        <div className="flex items-center gap-2 text-xs font-mono-ui text-slate-500 uppercase tracking-wider">
          <Icon size={14} className="text-[#D96B43]" /> {label}
        </div>
        <p className="mt-2 text-[15px] text-[#1C242B] leading-relaxed">{career[k]}</p>
      </div>
    ))}
  </div>
);
